// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_bN0","cls2":"PaperBrowserPreviewList-cls2_ISF PaperBrowserPreviewList-cls1_bN0"};